var theme = {}

// Youtube video controller
theme.Youtube_videos = new function () {
    // Add these tiny css rules http://www.funkertech.com/windows/w6/sass/bootstrap/_responsive-embed.scss
    // ==> ".embed-responsive" to parent with: ".embed-responsive-16by9" or ".embed-responsive-4by3"
    // ==> ".embed-responsive-item" to video placeholder

    // Should also add custom CSS rules to show/hide cover images or any other elements based on the status data selector
    // ==> ex, .embed-responsive[data-activity-status="playing"], .embed-responsive[data-activity-status="ended"]

    var self = this;

    self.initiated = false;
    self.players = [];
    self.array_videos = [];
    self.lastVideoPlay = null;

    self.selectors = {
        VIDEO : "[data-youtube-id]",
        PARENT : ".embed-responsive",
        TRIGGER : ".embed-video-trigger"
    };

    self.data_selectors = {
        INITIATED : 'initiated',
        YOUTUEB_ID : 'youtubeId',
        STATUS : 'activity-status'
    };

    // TODO: revoir.
    $('[data-video-close]').on('click', function() {
        try {
            self.players[self.lastVideoPlay].player.pauseVideo();
        } catch(err){
            console.log(err)
        }
    })

    function youtube_videos () {
        // Only init if there are youtube placeholders on the page
        if (!$(self.selectors.VIDEO).length) return;

        // Attach cover click events
        $('body').on("click", self.selectors.TRIGGER, function (e) {
            e.preventDefault();
            var current_id = $(this).attr("class").split(' ')[0];
            self.play_video($(this).closest(self.selectors.PARENT), current_id);
        })

        // only load script if the widget was not initiated beforehand.
        if (!self.initiated) {
            // add youtube script
            var tag = document.createElement('script');

            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            // wait for youtube activation
            window.onYouTubeIframeAPIReady = self.activation_listner;
        }
    }

    self.play_video = function ($parent, youtubeId) {
        try {

            self.array_videos.some(function(video, index) {
              if (video[1] != youtubeId) return false;

              var videoDomId = $parent.find(self.selectors.VIDEO).attr("id");
              if (self.players[videoDomId] != undefined) {
                  if (videoDomId != self.lastVideoPlay && self.lastVideoPlay != null) { // We can run only one video at a time, if another is being played => pause it.
                      self.players[self.lastVideoPlay].player.pauseVideo();
                  }
                  self.players[videoDomId].player.playVideo();
                  self.lastVideoPlay = videoDomId;
              } else {
                  self.initPlayer(video[0], video[1], video[2], video[3], index);
                  var videoDomId = $parent.find(self.selectors.VIDEO).attr("id");
              }

              return true;
            });
        } catch (e) {
            console.log("failed to play video");
            console.log(e.message);
        }
    }

    self.activation_listner = function () {
        self.initiated = true;
        self.iterate();
    }

    self.iterate = function () {
        $(self.selectors.VIDEO).each(function () {
            var videoHolder = $(this);
            if (videoHolder.data(self.data_selectors.INITIATED)) return;

            var youtubeId = videoHolder.data(self.data_selectors.YOUTUEB_ID);

            var domId = videoHolder.prop('id');
            if (!domId) {
              var random = Math.floor(Math.random() * 60000) + 1000;
              domId = 'youtube-placeholder-' + youtubeId + '-' + random;
              videoHolder.attr('id', domId);
            }

            var showControles = videoHolder.data('controls') || 0;
            var autoplay = videoHolder.data('autoplay') || 0;
            var fullscreenAllowed = videoHolder.data('fs') || 0;
            var releventVideos = videoHolder.data('rel') || 0;
            var loop = videoHolder.data('loop') || 0;

            self.array_videos.push([domId, youtubeId, {
                height: '390',
                width: '640',
                showinfo: 0,
                rel: releventVideos || 0,
                fs: fullscreenAllowed || 0,

                // Afficher les controles de la video en option (data attribute)
                controls: showControles || 0,

                // AutoPlay en option (data attribute), il faut ajouter mute: 1 car navigateur ne permet plus de lancer des videos avec son.
                autoplay: autoplay || 0,
                mute: autoplay || 0,

                // Permettre de lire la video indéfiniment en option (data attribute)
                loop: loop || 0,

                enablejsapi: 1
            }, false ]);

            if (autoplay == 1) {
                self.play_video($("#" + videoHolder.attr('id')).closest(self.selectors.PARENT), youtubeId);
            }
        });
    }

    self.initPlayer = function (domId, videoId, options, isActive, index) {
        if (isActive) return;

        var settings = {
            videoId: videoId,
            events: {
                'onReady': function (event) {
                  self.onPlayerReady(event, index);
                },
                'onStateChange': self.onPlayerStateChange
            }
        };

        settings.playerVars = options;
        var player = new YT.Player(domId, settings);

        var updatedSetting = options || {};
        updatedSetting.player = player;
        self.players[domId] = options || {};

        var videoHolder = $(this);
        videoHolder.data(self.data_selectors.INITIATED, true);
    }

    self.onPlayerReady = function (event, index) {
        var player = event.target;
        var vidDomId = event.target.l.id;
        var playerSettings = self.players[vidDomId];

        if (vidDomId != self.lastVideoPlay && self.lastVideoPlay != null) {
            self.players[self.lastVideoPlay].player.pauseVideo();
        }

        // Mark the current video as active and all the others as inactive.
        for (var i=0; i < self.array_videos.length; i++) {
          var status = false;
          if (i == index) status = true;
          self.array_videos[i][3] = status;
        }

        self.lastVideoPlay = vidDomId;
        player.playVideo();
    }

    self.onPlayerStateChange = function (event) {
        var player = event.target;
        var parent = event.target.f.parentElement;
        var playerId = event.target.l.id;
        var playerSettings = self.players[playerId];

        if (event.data == YT.PlayerState.ENDED) {
            parent.setAttribute('activity-status', 'ended');
        } else if (event.data == YT.PlayerState.PLAYING) {
            parent.setAttribute('activity-status', 'playing');
        } else if (event.data == YT.PlayerState.PAUSED) {
            parent.setAttribute('activity-status', 'paused');
        } else if (event.data == YT.PlayerState.BUFFERING) {
            parent.setAttribute('activity-status', 'buffering');
        } else if (event.data == YT.PlayerState.CUED) {
            parent.setAttribute('activity-status', 'cued');
        } else if (event.data == YT.PlayerState.UNSTARTED) {
            player.playVideo();
        }
    }

    return youtube_videos;
}

var youtubeController = new theme.Youtube_videos();

/****************** */
theme.slickSliderVideo = new function() {

  function slickSliderVideo() {

    // init default settings
    var settings = {
      selector: '[data-slider-video]',
      selectorData : 'slider-video'
    };

    // init flickity default settings
    var slickSettings = {
      "responsive": [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true
            }
          }
        ]
    };

    // iterate across all slider
    $(settings.selector).each(function() {

      var $currentEl = $(this);
      // get elements settings
      var elementSettings = $currentEl.data(settings.selectorData);
      // merge default settings with elements settings
      var finalSettings = $.extend({}, slickSettings, elementSettings);
      // wait all images in slider are loaded
      $currentEl.imagesLoaded( function() {
        // init carousel
        var $carousel = $currentEl.slick(finalSettings);
      });

    });
  }
  return slickSliderVideo;
}

var slickSliderVideo = new theme.slickSliderVideo();

theme.animateTitles = new function() {

  function animateTitles() {

    // init default settings
    var settings = {
      selectorTitleUnderline: '[data-title-underline]'
    };

    // iterate across all slider
    $(settings.selectorTitleUnderline).each(function() {
      $(window).on('scroll', function(){
        console.log($(this));
        console.log($(this).is(':visible'));
        if ($(this).is(':visible')) {
            $(this).addClass("active");
        }
      });

    });
  }
  return animateTitles;
}

var animateTitles = new theme.animateTitles();

/**************************
  Video Vimeo
***************************/


theme.videoVimeo = new function() {

  var self = this;

  self.selectors = {
      TRIGGER : ".embed-video-trigger-vimeo"
  };

  function videoVimeo() {

    var settings = {
      imgSelector : '[data-video-play-cover]',
      selectorData : 'video-play-cover'
    };

    $(settings.imgSelector).each(function() {
      var el = $(this);
      var idVideo = 'video-product-presentation-' + el.data(settings.selectorData);
      $('body').on("click", self.selectors.TRIGGER, function (e) {
          e.preventDefault();
          var iframe = document.getElementById(idVideo);
          // $f == Froogaloop
          var player = $f(iframe);
          var parent = el.context.parentNode;
          parent.setAttribute('activity-status', 'playingvimeo');
          player.api("play");
      });
    });
  }

  return videoVimeo;
}

var videoVimeo = new theme.videoVimeo();

/**************************
  Open reviews product page
***************************/


theme.reviewsProductPage = new function() {

  function reviewsProductPage() {

    var settings = {
      reviewsTab : '[data-product-tab-reviews]',
      reviewsLink : '[data-product-tab-reviews-link]'
    };

    $(settings.reviewsLink).on("click", function () {
        $(settings.reviewsTab).addClass('is-active');
    });
  }

  return reviewsProductPage;
}

var reviewsProductPage = new theme.reviewsProductPage();
